var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8521 55C43.0399 55 55.3521 42.6878 55.3521 27.5C55.3521 12.3122 43.0399 0 27.8521 0C12.6642 0 0.352051 12.3122 0.352051 27.5C0.352051 42.6878 12.6642 55 27.8521 55ZM26.7033 33.6963L37.37 22.6963L35.9342 21.304L25.9572 31.5927L19.7415 25.6758L18.3626 27.1244L25.2959 33.7244L26.0135 34.4076L26.7033 33.6963Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.95ef99e1844ddcec92130a05c9c1b58f.svg";
export { ForwardRef as ReactComponent };